import { TranslationRequest } from "src/app/shared/models/translation/translation-request";
import { TranslationService } from "../services/translation.service";

export class AbsenceReport {
  claimId: string;
  claimNumber: string;
  source: string;
  message: string;
  absences: AbsenceInfo[];
}

export class AbsenceInfo {
  dateOfAbsence: Date;
  dateOfReturn: Date;
  hours: number;
  minutes: number;
  reason: string;
  reasonDescription: string;
  confirmationNumber: string;

  constructor(
    public translationService: TranslationService
  ) {}

  result(translationRequest?: TranslationRequest): string {
    let hoursText = this.translationService.getTranslationForKey('hours', translationRequest);
    let minutesText = this.translationService.getTranslationForKey('minutes', translationRequest);
    return `${this.hours} ${hoursText} ${this.minutes} ${minutesText}`;
  }

  get reasonText(): string | null {
    if (!this.reason) {
      return null;
    }
    return this.reason;
  }
}

export class AbsenceInfoRequest {
  date: string;
  hours: number;
  minutes: number;
  reason: string;
  id: string;
  reasonText: string;
  employeeId: string;
  confirmation: string;
  messageId: string;
}

export class ReportAbsenceInfoRequest {
  claimId: string;
  claimNumber: string;
  source: string;
  message: string;
  absences: AbsenceInfoRequest[];
}

export class ReportIntermittentAbsenceResponse {
  success: boolean;
  message: string;
  confirmationId: number;
}
